import { CREATE_TICKET } from 'modules/dashboard/store/constants';

export const createTicket = (message) => ({
  type: CREATE_TICKET,
  payload: {
    message,
  },
});
